/**
 * Formulario: validación
 * Instrucciones:
 * 3 argumentos:
 * - elements: utilizamos la clase $('.validate-control') que se ha incluido en los elementos a controlar.
 * - submitBtn: $('#submitBtn') Elemento input submit.
 * - messages: objeto donde la clave debe ser igual al id del input que tendrá el mensaje de error.
 * En el valor se anota el comentario a mostrar.
 * - fileLimit: límite total, la suma de los 2 input file no debe superar este límite.
 */
class FormValidate {
    constructor(elements, submitBtn, messages, fileLimit) {
        this.elements = elements;
        this.submitBtn = submitBtn;
        this.messages = messages;
        this.totalSize = 0;
        this.letterSize = 0;
        this.curriculumSize = 0;
        this.filesCorrect = true;
        this.fileLimit = fileLimit;
    }

    /**
     * Inicio de validación
     */
    init() {
        this.verifyAtInit();
        $('#maxSize').text(this.fileLimit);
        this.elements.keyup(this.setDirty.bind(this, $(this)));
        this.elements.change(this.setDirty.bind(this, $(this)));
        this.verifyInputFiles();
    }

    /**
     * Verficar al inicio si los inputs están rellenados, entonces añade '.isDirty'
     */
    verifyAtInit(){
        this.elements.each((index, ele) => {
            if($(ele).val()){
                $(ele).addClass('isDirty');
                if($(ele)[0].type === 'checkbox'){
                    $(ele).removeClass('isDirty');
                }
            }
        });
    }

    /**
     * Control de elementos del formulario
     * @param ele
     */
    controlError(ele) {
        const type = $(ele)[0].type;
        type === 'email' && this.elements.keyup(this.verifyEmail.bind(this, ele));
        type === 'email' && this.elements.blur(this.verifyEmail.bind(this, ele));
        if ($(ele).val() === '' && $(ele).hasClass('isDirty')) {
            type === 'email' && this.verifyEmail(ele);
            type === 'select-one' && $(ele).closest('.select-wrapper').addClass('error');
            $(ele).addClass('error');
            this.addMessages(ele);
        } else {
            type === 'select-one' && $(ele).closest('.select-wrapper').removeClass('error');
            $(ele).removeClass('error');
            this.removeMessages(ele);
        }

        /**
         * Checkbox
         */
        if (type === 'checkbox') {
            if (!$(ele).is(':checked') && $(ele).hasClass('isDirty')) {
                $(ele).closest('.check-container').addClass('error');
                $(ele).addClass('error');
            } else {
                $(ele).closest('.check-container').removeClass('error');
                $(ele).removeClass('error');
                this.removeMessages(ele);
            }
        }
    }

    /**
     * E-mail
     * @param ele
     */
    verifyEmail(ele) {
        const emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (emailFormat.test($(ele).val())) {
            $(ele).removeClass('error');
            this.removeMessages(ele);
        } else {
            $(ele).addClass('error');
            this.addMessages(ele);
        }
        this.trySubmit()
    }

    /**
     * Inputs files, validación según suma del peso
     */
    verifyInputFiles() {

        /**
         * Primer input file
         * @type {*|jQuery|HTMLElement}
         */
        const letterFile = $('#letterFile');
        letterFile.change((e) => {
            const fileData = e.target.files[0];
            if (fileData) {
                /**
                 * Control de archivo .pdf
                 */
                if (fileData.type === 'application/pdf') {
                    $('#letterFile-text').text(fileData.name);
                    $('#letterSize').text(fileData.size);
                    this.letterSize = this.bytesToMegaBytes(fileData.size);
                    this.setTotalSize();
                } else {
                    letterFile.val('');
                    $('#letterSize').text(0);
                    letterFile.closest('.form-group').find('.message').text('El archivo adjunto no es un PDF y no será enviado');
                    this.letterSize = this.bytesToMegaBytes(0);
                    this.setTotalSize();
                }
            }
        });

        /**
         * Botón reset para primer input file
         */
        $('#letterFileReset').click(() => {
            letterFile.closest('.form-group').find('.message').text('');
            letterFile.val('');
            $('#letterSize').text(0);
            this.letterSize = this.bytesToMegaBytes(0);
            this.setTotalSize();
        });

        /**
         * Segundo input file
         * @type {*|jQuery|HTMLElement}
         */
        const curriculumFile = $('#curriculumFile');
        curriculumFile.change((e) => {
            const fileData = e.target.files[0];
            if (fileData) {
                /**
                 * Control de archivo .pdf
                 */
                if (fileData.type === 'application/pdf') {
                    $('#curriculumFile-text').text(fileData.name);
                    $('#curriculumSize').text(fileData.size);
                    this.curriculumSize = this.bytesToMegaBytes(fileData.size);
                    this.setTotalSize();
                } else {
                    curriculumFile.val('');
                    $('#curriculumSize').text(0);
                    curriculumFile.closest('.form-group').find('.message').text('El archivo adjunto no es un PDF y no será enviado');
                    this.curriculumSize = this.bytesToMegaBytes(0);
                    this.setTotalSize();
                }
            }
        });

        /**
         * Botón reset para segundo input file
         */
        $('#curriculumFileReset').click(() => {
            curriculumFile.closest('.form-group').find('.message').text('');
            curriculumFile.val('');
            $('#curriculumSize').text(0);
            this.curriculumSize = this.bytesToMegaBytes(0);
            this.setTotalSize();
        });
    }

    /**
     * Conversor bytes a MB
     * @param bytes
     * @returns {string}
     */
    bytesToMegaBytes(bytes) {
        return (bytes / (1024 * 1024)).toFixed(3);
    }

    /**
     * Suma de los 2 inputs files
     */
    setTotalSize() {
        this.totalSize = parseFloat(this.letterSize) + parseFloat(this.curriculumSize);
        $('#totalSize').text(this.totalSize);
        if (this.totalSize > this.fileLimit) {
            //$('#submitBtn').attr('disabled', true);
            $('#fileErrorMessage').text(`Se ha superado el límite de ${this.fileLimit}MB.`);
            this.filesCorrect = false;
        } else {
            //$('#submitBtn').attr('disabled', false);
            this.filesCorrect = true;
            $('#fileErrorMessage').text('');
        }
        this.trySubmit();
    };

    /**
     * Setea la clase 'isDirty' para indicar que el elemento ha sido modificado
     * @param self
     * @param ele
     */
    setDirty(self, ele) {
        this.controlError.bind(this, ele.target)();
        $(ele.target).addClass('isDirty');
        this.trySubmit();
    }

    /**
     * Añade el mensaje de error
     * @param ele
     */
    addMessages(ele) {
        const message = (ele.type === 'email' && $(ele).val() !== '' ? this.messages[ele.id + 'Fail'] : this.messages[ele.id]);
        Object.keys(this.messages).forEach((prop) => {
            if (ele.id === prop) {
                $('#' + ele.id + '-message').text(message);
                $('#' + ele.id + '+.error-message').show();
            }
        });
    }

    /**
     * Elimina el mensaje de error
     * @param ele
     */
    removeMessages(ele) {
        Object.keys(this.messages).forEach((prop) => {
            if (ele.id === prop) {
                $('#' + ele.id + '+.error-message').hide();
                $('#' + ele.id + '-message').text('');
            }
        });
    }

    /**
     * Comprueba que el formulario pase la validación correctamente para mostrar el botón de submit
     */
    trySubmit() {
        let counter = 0;
        this.elements.each((i) => {
            if (this.elements.eq(i).hasClass('isDirty') && !this.elements.eq(i).hasClass('error')) {
                counter++;
            }
        });
        if (counter === this.elements.length && this.filesCorrect) {
            this.submitBtn.attr('disabled', false);
        } else {
            this.submitBtn.attr('disabled', true);
        }
    }
}

/**
 * Instancia y parámetros
 */
const messages = {
    name: 'El nombre es obligatorio',
    surnames: 'Los apellidos son obligatorios',
    email: 'El email es obligatorio',
    emailFail: 'El E-mail no es correcto',
    phone: 'El teléfono es obligatorio'
};

const fileLimit = 5;

/**
 * Argumentos: clase de elementos para controlar, input submit, mensajes, límite total de peso (input file)
 * @type {FormValidate}
 */
const formValidate = new FormValidate($('.validate-control'), $('#submitBtn'), messages, fileLimit);
formValidate.init();





/**
 * Animación footer (recogido de https://doubleyou.com/js/home.js
 */

$('.DYFooterBoxContainer').on("mouseenter", function () {
    $('.DYFooterBoxContainer').removeClass("open");
    $(this).addClass("open");
});

$("#carouselContainer .back").on("click", function (e) {
    e.preventDefault();
});
